import { GenericHeader, GenericFooter } from '@icij/murmur'

import ChartRoute from './ChartRoute'
import ChartTargetedStakeholders from '../components/charts/ChartTargetedStakeholders'
import ChartUberExpansionMap from '../components/charts/ChartUberExpansionMap'
import ChartUberExpansionGrowth from '../components/charts/ChartUberExpansionGrowth'
import ChartHighLevelMeetings from '../components/charts/ChartHighLevelMeetings'

import Home from '../views/Home.vue'

export { guards } from './guards'
export { ChartRoute }
export const routes = [
  {
    path: '/',
    name: 'Home',
    props: {
      header: {
        noHeadroom: true,
        position: 'static'
      }
    },
    components: {
      header: GenericHeader,
      footer: GenericFooter,
      default: Home
    }
  },
  {
    path: '/embed/',
    name: 'Embed',
    components: {
      default: Home
    }
  },
  ChartRoute.create({ title: 'Uber’s global expansion', chart: ChartUberExpansionMap }),
  ChartRoute.create({ title: 'Uber’s global expansion', chart: ChartUberExpansionGrowth, name: 'ubers-global-expansion-growth' }),
  ChartRoute.create({ title: 'Uber’s search for powerful friends', chart: ChartTargetedStakeholders }),
  ChartRoute.create({ title: 'Uber’s high-level access', chart: ChartHighLevelMeetings })
]
